
document.addEventListener( 'wpcf7submit', function( event ) {
    
    // Contact Form
    if ( '8' == event.detail.contactFormId ) {
        const subject = document.querySelector( 'input[name="your-subject"]:checked' ).value; 
        //console.log(subject);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'contactus_form',
            'form_subject': subject // 'ask_question' or 'book_demo'
        });
    }
    // Book a demo
    if ( '19' == event.detail.contactFormId ) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'bookdemo_form'
        });
           
    }
    

}, false );